import { AiFillPrinter } from 'react-icons/ai';
import { ImPhone } from 'react-icons/im';
import { MdEmail } from 'react-icons/md';

import GOOGLE_API_KEY from '../../utils/googleAPIKey';
import CustomHead from '../CustomHead';
import EmailForm from '../EmailForm/EmailForm';
import PageTitle from '../Page Title/PageTitle';

import styles from './ContactLayout.module.scss';

export default function ContactLayout({ contactInfo }) {
  const title = contactInfo?.fields?.contactTitle;
  const sections =contactInfo?.fields?.section;
  return (
    <>
      <CustomHead title="Επικοινώνησε μαζί μας" key="title" />
      <PageTitle title="Επικοινώνησε μαζί μας" heading="Contact Us" />
      <section className={styles.container}>
        <div className={styles.contactContainer}>
          <h2 className={styles.heading}>{title}</h2>
          {sections?.map(section => (<div className={styles.row}>
            <div className={styles.rowContent}>
              <div className={styles.rowContentColumn}>
                <p className={styles.contactTitle}>{section.addressTitle}</p>
                <p className={styles.contactText}>{section.address}</p>
              </div>
            </div>
            <div className={styles.rowContent}>
              {section?.phoneNumber && <div className={styles.rowContentColumn}>
                <p className={styles.contactTitle}>
                  <ImPhone className={styles.icon} alt="phone icon"/>
                  {section?.phoneTitle}
                </p>
                <p className={styles.contactText}>{section.phoneNumber}</p>
              </div>}
              {section?.faxNumber && <div className={styles.rowContentColumn}>
                <p className={styles.contactTitle}>
                  <AiFillPrinter className={styles.icon} alt="printer"/>
                  {section?.faxTitle}
                </p>
                <p className={styles.contactText}>{section.faxNumber}</p>
              </div>}
              {section?.email && <div className={styles.rowContentColumn}>
                <p className={styles.contactTitle}>
                  <MdEmail className={styles.icon} alt="email"/>
                  {section?.emailTitle}
                </p>
                <p className={styles.contactText}>{section.email}</p>
              </div>}
            </div>
          </div>))}

          <div className={styles.row}>
            <div className={styles.rowContent}>
              {contactInfo?.fields?.schedule && <div className={styles.rowContentColumn}>
                <p className={styles.contactTitle}>{contactInfo?.fields?.scheduleTitle}</p>
                <p className={styles.contactText}>{contactInfo?.fields?.schedule}</p>
              </div>}
            </div>
            {contactInfo?.fields?.phoneforcustomers && <div className={styles.rowContent}>
              <div className={styles.rowContentColumn}>
                <p className={styles.contactTitle}>
                  <ImPhone className={styles.icon} alt="phone icon"/>
                  {contactInfo?.fields?.customerPhone}
                </p>
                <p className={styles.contactText}>{contactInfo?.fields?.phoneforcustomers}</p>
              </div>
            </div>}
            {contactInfo?.fields?.emailForCustomers && <div className={styles.rowContent}>
              <div className={styles.rowContentColumn}>
                <p className={styles.contactTitle}>
                  <MdEmail className={styles.icon} alt="email"/>
                  {contactInfo?.fields?.customerEmail}
                </p>
                <p className={styles.contactText}>{contactInfo?.fields?.emailForCustomers}</p>
              </div>
            </div>}
          </div>
        </div>

        {contactInfo?.fields?.googlemapquery &&
        (<div className={styles.mapContainer}>
          <iframe
            title="map"
            width="100%"
            height="100%"
            src={`//www.google.com/maps/embed/v1/place?key=${GOOGLE_API_KEY}&q=${contactInfo?.fields?.googlemapquery}`}
          />
        </div>)}
      </section>

      <section className={styles.formContainer}>
        <EmailForm />
      </section>
    </>
  );
}
